export default __webpack_public_path__ + "static/media/lose.83653309.mp3";